export type FetchOperationFailureType =
  | 'NO_ACCESS_KEY'
  | 'NO_QUERY_URL'
  | 'EMPTY_QUERY'
  | 'FETCH_FAILED'
  | 'INVALID_KEY'
  | 'INVALID_RESPONSE'
  | 'ACCESS_DENIED'
  | 'QUERY_FAILED'

export function isFetchError(error: unknown): error is FetchError {
  return error instanceof FetchError
}

export function isFetchErrorWithCode(error: unknown, code: FetchOperationFailureType): boolean {
  return isFetchError(error) && error.type === code
}

export class FetchError extends Error {
  constructor(
    message: string,
    public type: FetchOperationFailureType,
    public originalStatus?: string,
    public cause?: Error
  ) {
    super(message)
    this.name = 'FetchError'
  }
  static isFetchError = isFetchError
  static isFetchErrorWithCode = isFetchErrorWithCode
}
